import { Doughnut } from 'react-chartjs-2';
import PropTypes from 'prop-types';
import { useHistory } from 'react-router-dom';
import EmptyChart from 'components/EmptyChart';
import DashboardTitle from '../DashboardTitle';
import DashboardLabel from '../DashboardLabel';

const DashboardDoughnut = ({
  dataValues,
  title,
  description,
  onDetailClick
}) => {
  const history = useHistory();

  let labels = [];
  let values = [];
  let colors = [];

  dataValues.forEach(({ label, value, color }) => {
    labels = [...labels, label];
    values = [...values, value];
    colors = [...colors, color];
  });

  const options = {
    layout: {
      padding: {
        right: 20,
        bottom: 20,
        top: 20
      }
    },
    responsive: true,
    maintainAspectRatio: false,
    cutout: '60%',
    plugins: {
      legend: {
        display: false
      }
    }
  };

  const data = {
    labels,
    datasets: [
      {
        data: dataValues.flatMap((dataValue) => dataValue.value),
        backgroundColor: colors,
        borderWidth: 0
      }
    ]
  };
  return (
    <>
      <div className="flex flex-wrap h-full cursor-pointer">
        {title && (
          <DashboardTitle
            title={title}
            description={description}></DashboardTitle>
        )}
        {dataValues.length === 0 && <EmptyChart />}
        <div className="w-1/2">
          <Doughnut
            data={data}
            options={options}
            getElementAtEvent={(element) => {
              if (element.length) {
                if (onDetailClick) {
                  onDetailClick(element[0].index);
                } else {
                  history.push('/main/dashboard-detail');
                }
              }
            }}
          />
        </div>

        <div className="w-1/2 m-auto">
          <div
            style={{ width: 'fit-content', margin: 'auto' }}
            className="text-center w-screen">
            {labels.map((label, index) => (
              <span
                key={index}
                onClick={() => {
                  if (onDetailClick) {
                    onDetailClick(index);
                  } else {
                    history.push('/main/dashboard-detail');
                  }
                }}>
                <DashboardLabel
                  value={values[index]}
                  label={label}
                  color={colors[index]}
                />
              </span>
            ))}
          </div>
        </div>
      </div>
    </>
  );
};

/**
 * Component definition of proptypes.
 */
DashboardDoughnut.propTypes = {
  dataValues: PropTypes.array,
  title: PropTypes.string,
  description: PropTypes.string,
  selectMenu: PropTypes.object,
  onDetailClick: PropTypes.func,
  onSelectItem: PropTypes.func
};

export default DashboardDoughnut;
